import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { CreateLocalLink } from '../../utils/relative-url'
import MarketSelect from '../MarketSelect'

const FooterMenuWrap = styled.footer`
  ${tw`mb-10`}
  min-width: 280px;
`

const Menu = styled.nav`
  ${tw`tracking-wider`}

  a {
    ${tw`font-extended text-base`}
    ${tw`block py-1 opacity-75`}
  }
`

export default function FooterMenu() {
  const data = useStaticQuery(graphql`
    fragment MenuItem on WpMenuItem {
      id
      label
      url
    }

    query {
      allWpMenuItem(filter: { locations: { eq: FOOTER_MENU } }) {
        nodes {
          ...MenuItem
        }
      }
      wp {
        globalSettings {
          press {
            pressSeoDescription
          }
        }
      }
    }
  `)

  const menuItems = data.allWpMenuItem.nodes

  const seoDesc = data.wp.globalSettings.press.pressSeoDescription

  return (
    <FooterMenuWrap>
      <p className="mb-10 max-w-lg opacity-75 hidden md:block font-mono text-base">
        {seoDesc ||
          'Colekt your niche clean Fragrance and Skincare, an urban contemporary lifestyle for you. Colekt is a Stockholm-based brand in creation and exploration inspired by Scandi nature, the cultural heritage and seasonal mood.'}
      </p>
      <Menu>
        {menuItems &&
          menuItems.map((item, key) => (
            <Link key={key} to={CreateLocalLink(item.url)}>
              {item.label}
            </Link>
          ))}
      </Menu>
      <MarketSelect />
    </FooterMenuWrap>
  )
}
